import { Injectable } from '@angular/core';
import { UsuarioEnSesionService } from './usuario-en-sesion.service';
import { InterfazService } from './interfaz.service';
import { BreadcrumbService } from './breadcrumb.service';

@Injectable({
  providedIn: 'root'
})
export class FacadeSesionService {

  constructor(
    public usuarioEnSesionService: UsuarioEnSesionService,
    public interfazService: InterfazService,
    public breadcrumbService: BreadcrumbService
  ) { }
  inicializar() {
    this.usuarioEnSesionService.inicializar();
    this.interfazService.inicializar();
    this.breadcrumbService.inicializar();
  }
}